import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-536bd42c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-0" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = {
  key: 0,
  class: "app-sidebar__business"
}
const _hoisted_4 = { class: "app-sidebar__product" }
const _hoisted_5 = {
  key: 1,
  "data-test": "section-Dashboard"
}
const _hoisted_6 = {
  class: "app-sidebar__list",
  role: "menu"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-dashboard app-sidebar__icon" }, null, -1))
const _hoisted_9 = ["id"]
const _hoisted_10 = ["aria-labelledby"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tag = _resolveComponent("tag")!
  const _component_product_select = _resolveComponent("product-select")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(["app-sidebar", {
        'app-sidebar--collapsible': _ctx.collapsible,
        'app-sidebar--collapsed': _ctx.isCollapsed && _ctx.collapsible,
      }]),
      "aria-expanded": (!_ctx.isCollapsed && _ctx.collapsible) || !_ctx.collapsible
    }, [
      (_ctx.businessName)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createVNode(_component_tag, {
              class: "overflow-x--ellipsis width--100",
              color: "grey",
              pill: "",
              title: _ctx.businessName
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.businessName), 1)
              ]),
              _: 1
            }, 8, ["title"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_product_select)
      ]),
      (!_ctx.hideDashboard)
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", {
                class: "app-sidebar__list--item",
                title: _ctx.isCollapsed && _ctx.collapsible ? 'Dashboard' : undefined
              }, [
                _createVNode(_component_router_link, {
                  to: { name: 'Dashboard' },
                  class: "app-sidebar__list--link",
                  "aria-current": _ctx.calcCurrent('/dashboard')
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createElementVNode("span", {
                      class: _normalizeClass(["app-sidebar--collapsed__text", { 'app-sidebar--collapsed__text--hidden': _ctx.isCollapsed && _ctx.collapsible }])
                    }, "Dashboard", 2)
                  ]),
                  _: 1
                }, 8, ["aria-current"])
              ], 8, _hoisted_7)
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebarList, (sidebarItem) => {
        return (_openBlock(), _createElementBlock("section", {
          key: sidebarItem.headerText
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(["app-sidebar__header app-sidebar--collapsed__text", { 'app-sidebar--collapsed__text--hidden': _ctx.isCollapsed && _ctx.collapsible }]),
            id: `sidebar-header-${sidebarItem.headerText}`
          }, _toDisplayString(sidebarItem.headerText), 11, _hoisted_9),
          _createElementVNode("ul", {
            class: "app-sidebar__list",
            role: "menu",
            "aria-labelledby": `sidebar-header-${sidebarItem.headerText}`
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sidebarItem.menuItems, (menuItem) => {
              return (_openBlock(), _createElementBlock("li", {
                key: menuItem.text,
                class: "app-sidebar__list--item"
              }, [
                _createVNode(_component_router_link, {
                  to: menuItem.to,
                  class: _normalizeClass(["app-sidebar__list--link", { 'overflow-x--ellipsis': !(_ctx.isCollapsed && _ctx.collapsible) }]),
                  "data-test": `link-${menuItem.text.replace(/\s/g, '')}`,
                  title: _ctx.isCollapsed && _ctx.collapsible ? menuItem.text : undefined,
                  "aria-current": _ctx.calcCurrent(menuItem.to.toString())
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(["app-sidebar__icon", `icon-${menuItem.icon}`])
                    }, null, 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(["app-sidebar--collapsed__text", { 'app-sidebar--collapsed__text--hidden': _ctx.isCollapsed && _ctx.collapsible }])
                    }, _toDisplayString(menuItem.text), 3)
                  ]),
                  _: 2
                }, 1032, ["to", "data-test", "class", "title", "aria-current"]),
                (menuItem.subItems)
                  ? (_openBlock(), _createElementBlock("ul", {
                      key: 0,
                      class: _normalizeClass(["app-sidebar__list--sub", { 'p-0': _ctx.isCollapsed && _ctx.collapsible }]),
                      role: "menu"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.subItems, (subItem) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          to: subItem.to,
                          key: subItem.text,
                          custom: ""
                        }, {
                          default: _withCtx(({ href }) => [
                            _createElementVNode("li", {
                              class: _normalizeClass(["app-sidebar__list--sub-item", { 'ml-1': _ctx.isCollapsed && _ctx.collapsible }])
                            }, [
                              _createElementVNode("a", {
                                class: "app-sidebar__list--sub-item__link font-size--body-text",
                                href: href
                              }, _toDisplayString(subItem.text), 9, _hoisted_11)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 8, _hoisted_10)
        ]))
      }), 128))
    ], 10, _hoisted_2),
    (_ctx.collapsible)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass(["app-sidebar--collapsible__list-item m-0", { 'app-sidebar--collapsed': _ctx.isCollapsed && _ctx.collapsible }])
        }, [
          _createElementVNode("li", {
            class: "app-sidebar__list--item",
            title: _ctx.isCollapsed && _ctx.collapsible ? 'Expand menu' : undefined
          }, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed)),
              href: "javascript:void(0)",
              class: "app-sidebar__list--link"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["app-sidebar__icon", `icon-${_ctx.isCollapsed && _ctx.collapsible ? 'expand' : 'collapse'}-menu`])
              }, null, 2),
              _createElementVNode("span", {
                class: _normalizeClass(["app-sidebar--collapsed__text", { 'app-sidebar--collapsed__text--hidden': _ctx.isCollapsed && _ctx.collapsible }])
              }, _toDisplayString(_ctx.isCollapsed ? 'Expand' : 'Collapse') + " menu", 3)
            ])
          ], 8, _hoisted_12)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}